import React from 'react'


const BackArrow = ({ onClick = () => {} }) => {
  return (
    <div className="back_arrow_container">
      <span onClick={onClick} className="back_arrow">
        <i className="material-icons ">arrow_back</i>
        <span>BACK</span>
      </span>
    </div>
  )
}
export default BackArrow
